module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_about01-5d90dc9bbcdc11ac012456a8838bc2b4.png";